import { useState, useEffect, useMemo } from "react";
import axios from "../../services/api/api";
import UpdatePasswordForm from "../../components/Forms/UpdatePasswordForm";
import { useLocation } from "react-router-dom";

function UpdatePassword() {
  const [hash, setHash] = useState(null);

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  const isFromApp = query.get("isFromApp")?.toLowerCase() === "true";

  const indexStartOfCheck =
    window.location.toString().indexOf("check=") + "check=".length;

  const check = window.location
    .toString()
    .substring(
      indexStartOfCheck,
      window.location.toString().indexOf("&isFromApp")
    );

  useEffect(() => {
    if (check) {
      axios
        .post("/password/validate", {
          hash: check,
        })
        .then((response) => {
          setHash(response.data.result);
        })
        .catch(() => {
          setHash(null);
        });
    }
  }, [check]);

  return <UpdatePasswordForm hash={hash} isFromApp={isFromApp} />;
}

export default UpdatePassword;
